var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamGraphPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.719,
    height: 20,
    viewBox: "0 0 32.719 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "empty",
    transform: "translate(0 -89.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84",
    "data-name": "Caminho 84",
    d: "M32.421,94.664l0-.006-3.554-4.425a.843.843,0,0,0-.133-.131.829.829,0,0,0-.635-.3H4.624a.828.828,0,0,0-.635.3.842.842,0,0,0-.133.131L.3,94.658l0,.006A.828.828,0,0,0,0,95.3V108.97a.834.834,0,0,0,.833.834H31.885a.834.834,0,0,0,.833-.834V95.3A.828.828,0,0,0,32.421,94.664Zm-3.492-1.687,1.195,1.487H28.929Zm-1.667-1.506v2.994H21.021a.834.834,0,0,0-.494.162L16.36,97.693l-4.167-3.067a.836.836,0,0,0-.494-.162H5.457V91.471ZM3.79,94.465H2.6L3.79,92.977v1.487Zm27.262,13.672H1.667V96.132h9.758L15.866,99.4a.834.834,0,0,0,.988,0l4.44-3.268h9.758v12.005Z",
    transform: "translate(0)",
    fill: "#ccc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamGraphPlaceholder);
export default __webpack_public_path__ + "static/media/team-graph-placeholder.fe84d6d01f45f673bd0472f98a76767d.svg";
export { ForwardRef as ReactComponent };